import React from "react";
import { AuthProvider } from "./context/authContext";
import { LoadingProvider } from "./context/loadingContext";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./Functions/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadingProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />


        <App />
      </BrowserRouter>
    </AuthProvider>
  </LoadingProvider>
);
reportWebVitals();
